import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {ProductSpecificRuleFilter, ProductSpecificRuleState} from "@/modules/product_specific_rule/types";
import {getProductSpecificRule, getProductSpecificRules} from "@/services/product_specific_rule";

export const state: ProductSpecificRuleState = {
  productSpecificRule: {
    id: 0,
    id_agreement: 0,
    id_harmonized_system_code: 0,
    origin_determination_condition: "",
    bd_percentage: 0,
    bu_percentage: 0,
    nc_percentage: 0,
    mc_percentage: 0,
    start_application_date: new Date(),
    end_application_date: new Date(),
  },
  productSpecificRules: []
}

const actions: ActionTree<ProductSpecificRuleState, RootState> = {
  async GET_PRODUCT_SPECIFIC_RULE(_, id) {
    return await getProductSpecificRule(id);
  },
  async GET_PRODUCT_SPECIFIC_RULES(_, payload: ProductSpecificRuleFilter) {
    return await getProductSpecificRules(payload);
  }
}

const mutations: MutationTree<ProductSpecificRuleState> = {
}

const getters: GetterTree<ProductSpecificRuleState, RootState> = {
}

export const product_specific_rule: Module<ProductSpecificRuleState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
